import React from 'react';
import Box from '@mui/material/Box';

export interface LayoutProps {
  style?: React.CSSProperties;
  className?: string;
  children?: React.ReactNode;
  hasSider?: boolean;
  [key: string]: any;
}

const Header: React.FC<{ style?: React.CSSProperties; className?: string; children?: React.ReactNode }> = ({
  style,
  className,
  children,
}) => (
  <Box component="header" className={className} sx={{ ...style }}>
    {children}
  </Box>
);

const Content: React.FC<{ style?: React.CSSProperties; className?: string; children?: React.ReactNode }> = ({
  style,
  className,
  children,
}) => (
  <Box component="main" className={className} sx={{ flex: 1, ...style }}>
    {children}
  </Box>
);

const Footer: React.FC<{ style?: React.CSSProperties; className?: string; children?: React.ReactNode }> = ({
  style,
  className,
  children,
}) => (
  <Box component="footer" className={className} sx={{ ...style }}>
    {children}
  </Box>
);

const Sider: React.FC<{
  style?: React.CSSProperties;
  className?: string;
  children?: React.ReactNode;
  width?: number | string;
  collapsed?: boolean;
  collapsedWidth?: number;
}> = ({ style, className, children, width = 200, collapsed, collapsedWidth = 80 }) => (
  <Box
    component="aside"
    className={className}
    sx={{
      width: collapsed ? collapsedWidth : width,
      flexShrink: 0,
      ...style,
    }}
  >
    {children}
  </Box>
);

const LayoutRoot: React.FC<LayoutProps> & {
  Header: typeof Header;
  Content: typeof Content;
  Footer: typeof Footer;
  Sider: typeof Sider;
} = ({ style, className, children, hasSider }) => (
  <Box
    className={className}
    sx={{
      display: 'flex',
      flexDirection: hasSider ? 'row' : 'column',
      minHeight: '100vh',
      ...style,
    }}
  >
    {children}
  </Box>
);

LayoutRoot.Header = Header;
LayoutRoot.Content = Content;
LayoutRoot.Footer = Footer;
LayoutRoot.Sider = Sider;

export const Layout = LayoutRoot;
export default Layout;
